import React, { useEffect, useState } from 'react';
import { Avatar, Badge, IconButton, Tooltip } from '@mui/material';
import {
  NotificationsRounded, SettingsRounded, MenuRounded,
  BusinessRounded, PeopleAltRounded, PaidOutlined, Handshake,
} from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { useAuth } from '../../../contexts/AuthContext';

const titleFor = (path) => {
  const parts = path.split('/').filter(Boolean);
  const key = parts[0] || 'dashboard';
  const map = {
    dashboard:'Dashboard', users:'Users', companies:'Companies', meetings:'Meetings', matchmaking:'AI Matchmaking',
    ads:'Advertisements', sponsorships:'Sponsorships', analytics:'Analytics', 'video-settings':'Video', video:'Video',
    employees:'Employees', crm:'CRM', 'employee-meetings':'Employee Meetings', 'subscription-plans':'Subscription Plans',
    registrations:'Incomplete Registrations', payments:'Payment Verification', 'audit-log':'Audit Log', settings:'Settings',
    notifications:'Notifications', profile:'My Profile', admin:'Support',
  };
  return map[key] || key.replace(/-/g,' ').replace(/\b\w/g,(c)=>c.toUpperCase());
};

const Header = ({ onMenu }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [notificationCount,setNotificationCount]=useState(0);

  useEffect(()=>{
    const uid = userData?.userId || userData?.uid;
    if (!uid) return undefined;
    const buckets = { legacy: new Map(), current: new Map() };
    const recompute = () => {
      const all = new Map([...buckets.legacy, ...buckets.current]);
      setNotificationCount(Array.from(all.values()).filter((data)=>data?.read !== true && data?.isRead !== true).length);
    };
    const unsubLegacy = onSnapshot(
      query(collection(db,'notifications'),where('userId','==',uid)),
      (snap)=>{buckets.legacy=new Map(snap.docs.map((d)=>[d.id,d.data()]));recompute();},
      (error)=>console.warn('Legacy notification counter unavailable:',error?.message||error)
    );
    const unsubCurrent = onSnapshot(
      query(collection(db,'notifications'),where('recipientId','==',uid)),
      (snap)=>{buckets.current=new Map(snap.docs.map((d)=>[d.id,d.data()]));recompute();},
      (error)=>console.warn('Notification counter unavailable:',error?.message||error)
    );
    return ()=>{unsubLegacy?.();unsubCurrent?.();};
  },[userData?.userId,userData?.uid]);

  const initials=String(userData?.displayName||userData?.email||'A').split(/\s+/).slice(0,2).map((v)=>v[0]||'').join('').toUpperCase();

  return (
    <header className="tf-admin-topbar">
      <IconButton className="tf-admin-mobile-menu" aria-label="Open navigation" onClick={onMenu}><MenuRounded /></IconButton>
      <div className="tf-admin-topbar-title">
        <span>TELCOFAIR · ADMIN WORKSPACE</span>
        <strong>{titleFor(location.pathname)}</strong>
      </div>
      <div className="tf-admin-topbar-actions">
        <button type="button" className="tf-admin-quick companies" onClick={()=>navigate('/companies')}><BusinessRounded/> Companies</button>
        <button type="button" className="tf-admin-quick users" onClick={()=>navigate('/users')}><PeopleAltRounded/> Users</button>
        <button type="button" className="tf-admin-quick payments" onClick={()=>navigate('/payments/manual')}><PaidOutlined/> Payments</button>
        <button type="button" className="tf-admin-quick crm" onClick={()=>navigate('/crm')}><Handshake/> CRM</button>
        <Tooltip title="Notifications"><IconButton onClick={()=>navigate('/notifications')}><Badge color="error" badgeContent={notificationCount} max={99}><NotificationsRounded/></Badge></IconButton></Tooltip>
        <Tooltip title="Settings"><IconButton onClick={()=>navigate('/settings')}><SettingsRounded/></IconButton></Tooltip>
        <Tooltip title="Profile"><Avatar src={userData?.profilePicture||userData?.photoURL||''} onClick={()=>navigate('/profile')} sx={{width:34,height:34,cursor:'pointer',fontSize:11,fontWeight:900,bgcolor:'#2E6F8E'}}>{initials}</Avatar></Tooltip>
      </div>
    </header>
  );
};
export default Header;
